import axiosInstance from "../../../../../../Utils/axios";
import axios from "axios";
import { paginationQueryParams } from "../../../../../../Utils/paginationParam";
let cancelToken;

const saleInvoiceURL = `api/v1/sales-app/sales-invoice`;

//obtaining the paginated data
export const getSaleInvoice = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(`${saleInvoiceURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`, {
    cancelToken: cancelToken.token,
  });
};

//obtaining all fiscal sessions
export const getAllSaleInvoice = () => axiosInstance.get(`${saleInvoiceURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageSaleInvoice = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(`${saleInvoiceURL}/list?${paginationQueryParams(rowsPerPage, search, "", number)}`);
// get by id
export const getSaleInvoiceById = (id) => axiosInstance.get(`${saleInvoiceURL}/retrieve/${id}`);

//get sale order detail from sale order master id
export const getSaleInvoiceDeliveryDetail = (id) => axiosInstance.get(`api/v1/sales-app/delivery-notes/retrieve/${id}`);

export const getSaleInvoiceAdditionalChargeList = () =>
  axiosInstance.get(`api/v1/core-app/additional-charge/list?is_active=true`);

//creating function
export const createSaleInvoice = (body) => axiosInstance.post(`${saleInvoiceURL}/customer/create`, body);
//updating function
export const updateSaleInvoice = (id, body) => axiosInstance.patch(`${saleInvoiceURL}/update/${id}`, body);

//searching function
export const handleSearch = ({ rowsPerPage, search, sortOrder }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(
    `${saleInvoiceURL}/list?offset=0&limit=${rowsPerPage}&ordering=${sortOrder}&search=${search}`,
    {
      cancelToken: cancelToken.token,
    }
  );
};
